import i18n from '../../../../i18n';

export const getPatronSubscriptionsLabel = (patronSubscriptions: number) =>
    patronSubscriptions > 0
        ? `${i18n.t('shop.subscriptions.usersSubscribed', {
              count: patronSubscriptions
          })}`
        : undefined;
